export const OILFIELD_PRODUCTION_CONST = 0.0614;

export const GEOTHERMAL_PRODUCTION_CONST = 1.2614;

export const GEOTHERMAL_PERCENT = 1;

export const OILFIELD_PERCENT = 1;

export const WELLS_AMOUNT = 1;

export const GEOTHERMAL_WELLS_DEFAULT = 3700;
export const OILFIELD_WELLS_DEFAULT = 570000;

export const WELLS_MARKET_MULTIPLIER = 1;

export type TCalculatedFunction = "median" | "mean";
export const CALCULATED_FUNCTIONS: Array<TCalculatedFunction> = [
	"mean",
	"median"
]

export interface IElement {
	value: number;
	label: string;
	minimumValue: number;
	maximumValue: number;
}

export const DEFAULT_COLUMNS = [
	{
		value: "id",
		label: "ID",
	},
	{
		value: "_c",
		label: "COUNTRY"
	},
	{
		value: "_r",
		label: "REGION"
	},
	{
		value: "_ft",
		label: "FLUID TYPE"
	},
	{
		value: "_lo",
		label: "LONGITUDE"
	},
	{
		value: "_la",
		label: "LATITUDE"
	},
	{
		value: "_sn",
		label: "SAMPLE NAME"
	}
]

export const ELEMENTS: Array<IElement> = [
	{
		"value" : 29,
		"label" : "I",
		"minimumValue" : 0.001,
		"maximumValue" : 2171.0
	},
	{
		"value" : 48,
		"label" : "Y",
		"minimumValue" : 5.0E-6,
		"maximumValue" : 0.16
	},
	{
		"value" : 18,
		"label" : "Au",
		"minimumValue" : 1.0E-6,
		"maximumValue" : 3.0
	},
	{
		"value" : 30,
		"label" : "Mo",
		"minimumValue" : 6.0E-6,
		"maximumValue" : 28.0
	},
	{
		"value" : 45,
		"label" : "Zr",
		"minimumValue" : 4.0E-6,
		"maximumValue" : 0.193
	},
	{
		"value" : 40,
		"label" : "Tl",
		"minimumValue" : 1.0E-6,
		"maximumValue" : 8.32
	},
	{
		"value" : 77,
		"label" : "H2S",
		"minimumValue" : 0.01,
		"maximumValue" : 23600.0
	},
	{
		"value" : 63,
		"label" : "Ho",
		"minimumValue" : 6.78516E-8,
		"maximumValue" : 0.6
	},
	{
		"value" : 23,
		"label" : "Cr",
		"minimumValue" : 1.0E-5,
		"maximumValue" : 5500.0
	},
	{
		"value" : 94,
		"label" : "C2H6",
		"minimumValue" : 0.03,
		"maximumValue" : 4.2
	},
	{
		"value" : 10,
		"label" : "Cl",
		"minimumValue" : 0.01,
		"maximumValue" : 555000.0
	},
	{
		"value" : 28,
		"label" : "Hg",
		"minimumValue" : 1.0E-5,
		"maximumValue" : 178.0
	},
	{
		"value" : 81,
		"label" : "CO3",
		"minimumValue" : 1.0E-4,
		"maximumValue" : 169123.0
	},
	{
		"value" : 75,
		"label" : "CO2",
		"minimumValue" : 0.1,
		"maximumValue" : 37440.0
	},
	{
		"value" : 64,
		"label" : "Er",
		"minimumValue" : 4.77094E-8,
		"maximumValue" : 2.15
	},
	{
		"value" : 59,
		"label" : "Eu",
		"minimumValue" : 7.90392E-8,
		"maximumValue" : 0.2
	},
	{
		"value" : 86,
		"label" : "P",
		"minimumValue" : 0.069,
		"maximumValue" : 9.1
	},
	{
		"value" : 62,
		"label" : "Dy",
		"minimumValue" : 7.67626E-8,
		"maximumValue" : 2.35
	},
	{
		"value" : 11,
		"label" : "F",
		"minimumValue" : 0.003,
		"maximumValue" : 22400.0
	},
	{
		"value" : 76,
		"label" : "PO4",
		"minimumValue" : 0.01,
		"maximumValue" : 9198.57
	},
	{
		"value" : 74,
		"label" : "NH4",
		"minimumValue" : 0.002,
		"maximumValue" : 10500.0
	},
	{
		"value" : 80,
		"label" : "HCO3",
		"minimumValue" : 0.01,
		"maximumValue" : 242994.0
	},
	{
		"value" : 49,
		"label" : "Pd",
		"minimumValue" : 2.0E-4,
		"maximumValue" : 0.034
	},
	{
		"value" : 97,
		"label" : "N2",
		"minimumValue" : 0.35,
		"maximumValue" : 93.35
	},
	{
		"value" : 56,
		"label" : "Pr",
		"minimumValue" : 7.13286E-8,
		"maximumValue" : 0.15
	},
	{
		"value" : 39,
		"label" : "Ti",
		"minimumValue" : 3.5E-4,
		"maximumValue" : 360.0
	},
	{
		"value" : 47,
		"label" : "Sc",
		"minimumValue" : 5.28431E-6,
		"maximumValue" : 0.104
	},
	{
		"value" : 46,
		"label" : "In",
		"minimumValue" : 3.0E-6,
		"maximumValue" : 2.16E-4
	},
	{
		"value" : 4,
		"label" : "Mg",
		"minimumValue" : 0.001,
		"maximumValue" : 78000.0
	},
	{
		"value" : 82,
		"label" : "BO3",
		"minimumValue" : 1.0,
		"maximumValue" : 716.5
	},
	{
		"value" : 9,
		"label" : "Br",
		"minimumValue" : 0.006,
		"maximumValue" : 10600.0
	},
	{
		"value" : 15,
		"label" : "Sr",
		"minimumValue" : 1.9E-5,
		"maximumValue" : 29200.0
	},
	{
		"value" : 7,
		"label" : "B",
		"minimumValue" : 0.0018,
		"maximumValue" : 10000.0
	},
	{
		"value" : 31,
		"label" : "Ni",
		"minimumValue" : 1.0E-5,
		"maximumValue" : 1200.0
	},
	{
		"value" : 6,
		"label" : "As",
		"minimumValue" : 1.0E-6,
		"maximumValue" : 2700.0
	},
	{
		"value" : 83,
		"label" : "KNa",
		"minimumValue" : 0.5,
		"maximumValue" : 573500.0
	},
	{
		"value" : 44,
		"label" : "Zn",
		"minimumValue" : 6.0E-6,
		"maximumValue" : 6100.0
	},
	{
		"value" : 5,
		"label" : "SiO2",
		"minimumValue" : 0.07,
		"maximumValue" : 9937.0
	},
	{
		"value" : 67,
		"label" : "Lu",
		"minimumValue" : 2.58177E-8,
		"maximumValue" : 0.4
	},
	{
		"value" : 16,
		"label" : "Ag",
		"minimumValue" : 1.0E-6,
		"maximumValue" : 12.4
	},
	{
		"value" : 99,
		"label" : "O2",
		"minimumValue" : 5.0E-4,
		"maximumValue" : 6.91
	},
	{
		"value" : 21,
		"label" : "Co",
		"minimumValue" : 4.0E-6,
		"maximumValue" : 475.0
	},
	{
		"value" : 33,
		"label" : "Rb",
		"minimumValue" : 1.15E-4,
		"maximumValue" : 5300.0
	},
	{
		"value" : 88,
		"label" : "Si",
		"minimumValue" : 0.079,
		"maximumValue" : 5555.0
	},
	{
		"value" : 72,
		"label" : "NO2",
		"minimumValue" : 0.01,
		"maximumValue" : 210.8
	},
	{
		"value" : 12,
		"label" : "Fe",
		"minimumValue" : 1.0E-4,
		"maximumValue" : 81800.0
	},
	{
		"value" : 60,
		"label" : "Gd",
		"minimumValue" : 2.89725E-7,
		"maximumValue" : 1.0
	},
	{
		"value" : 8,
		"label" : "Ba",
		"minimumValue" : 1.0E-5,
		"maximumValue" : 22400.0
	},
	{
		"value" : 35,
		"label" : "Sb",
		"minimumValue" : 5.0E-6,
		"maximumValue" : 17.8
	},
	{
		"value" : 78,
		"label" : "SO3",
		"minimumValue" : 0.05,
		"maximumValue" : 591.0
	},
	{
		"value" : 43,
		"label" : "W",
		"minimumValue" : 1.0E-6,
		"maximumValue" : 6.35
	},
	{
		"value" : 68,
		"label" : "Hf",
		"minimumValue" : 1.0E-6,
		"maximumValue" : 2.0E-5
	},
	{
		"value" : 13,
		"label" : "Li",
		"minimumValue" : 2.0E-5,
		"maximumValue" : 1700.0
	},
	{
		"value" : 22,
		"label" : "Cd",
		"minimumValue" : 1.0E-6,
		"maximumValue" : 40.0
	},
	{
		"value" : 66,
		"label" : "Yb",
		"minimumValue" : 2.41655E-7,
		"maximumValue" : 2.55
	},
	{
		"value" : 36,
		"label" : "Se",
		"minimumValue" : 1.0E-4,
		"maximumValue" : 33.0
	},
	{
		"value" : 71,
		"label" : "Te",
		"minimumValue" : 6.6E-4,
		"maximumValue" : 3.0
	},
	{
		"value" : 58,
		"label" : "Sm",
		"minimumValue" : 1.15516E-7,
		"maximumValue" : 0.35
	},
	{
		"value" : 3,
		"label" : "Ca",
		"minimumValue" : 0.01,
		"maximumValue" : 193359.0
	},
	{
		"value" : 38,
		"label" : "Th",
		"minimumValue" : 1.0E-6,
		"maximumValue" : 0.22
	},
	{
		"value" : 54,
		"label" : "La",
		"minimumValue" : 1.25727E-7,
		"maximumValue" : 0.34
	},
	{
		"value" : 20,
		"label" : "Bi",
		"minimumValue" : 5.0E-6,
		"maximumValue" : 5.0
	},
	{
		"value" : 61,
		"label" : "Tb",
		"minimumValue" : 9.57574E-8,
		"maximumValue" : 0.21
	},
	{
		"value" : 50,
		"label" : "Re",
		"minimumValue" : 4.0E-6,
		"maximumValue" : 0.062
	},
	{
		"value" : 27,
		"label" : "Ge",
		"minimumValue" : 3.0E-5,
		"maximumValue" : 5.0
	},
	{
		"value" : 2,
		"label" : "Na",
		"minimumValue" : 0.0085,
		"maximumValue" : 228813.0
	},
	{
		"value" : 57,
		"label" : "Nd",
		"minimumValue" : 5.30793E-7,
		"maximumValue" : 0.75
	},
	{
		"value" : 37,
		"label" : "Sn",
		"minimumValue" : 1.4E-6,
		"maximumValue" : 122.0
	},
	{
		"value" : 34,
		"label" : "S",
		"minimumValue" : 0.028791326,
		"maximumValue" : 71680.0
	},
	{
		"value" : 26,
		"label" : "Ga",
		"minimumValue" : 1.0E-6,
		"maximumValue" : 2.0
	},
	{
		"value" : 55,
		"label" : "Ce",
		"minimumValue" : 9.68695E-8,
		"maximumValue" : 0.92
	},
	{
		"value" : 90,
		"label" : "DOC",
		"minimumValue" : 1.0,
		"maximumValue" : 5960.0
	},
	{
		"value" : 1,
		"label" : "K",
		"minimumValue" : 0.03,
		"maximumValue" : 78196.0
	},
	{
		"value" : 25,
		"label" : "Cu",
		"minimumValue" : 2.0E-5,
		"maximumValue" : 330.0
	},
	{
		"value" : 93,
		"label" : "CH4",
		"minimumValue" : 0.001,
		"maximumValue" : 95.54
	},
	{
		"value" : 42,
		"label" : "V",
		"minimumValue" : 1.0E-5,
		"maximumValue" : 430.0
	},
	{
		"value" : 52,
		"label" : "Os",
		"minimumValue" : 1.88E-4,
		"maximumValue" : 8.0E-4
	},
	{
		"value" : 69,
		"label" : "Nb",
		"minimumValue" : 6.0E-6,
		"maximumValue" : 0.01
	},
	{
		"value" : 19,
		"label" : "Be",
		"minimumValue" : 1.0E-6,
		"maximumValue" : 7.0
	},
	{
		"value" : 79,
		"label" : "SO4",
		"minimumValue" : 0.01,
		"maximumValue" : 184400.0
	},
	{
		"value" : 84,
		"label" : "NO3",
		"minimumValue" : 0.02,
		"maximumValue" : 9469.0
	},
	{
		"value" : 89,
		"label" : "DIC",
		"minimumValue" : 0.399933,
		"maximumValue" : 1896.0
	},
	{
		"value" : 91,
		"label" : "TOC",
		"minimumValue" : 0.25,
		"maximumValue" : 5680.0
	},
	{
		"value" : 41,
		"label" : "U",
		"minimumValue" : 3.0E-6,
		"maximumValue" : 6.8
	},
	{
		"value" : 73,
		"label" : "NO3N",
		"minimumValue" : 0.0025,
		"maximumValue" : 1155.0
	},
	{
		"value" : 51,
		"label" : "Pt",
		"minimumValue" : 5.4E-7,
		"maximumValue" : 0.1
	},
	{
		"value" : 65,
		"label" : "Tm",
		"minimumValue" : 8.39914E-8,
		"maximumValue" : 0.35
	},
	{
		"value" : 14,
		"label" : "Mn",
		"minimumValue" : 6.5E-5,
		"maximumValue" : 7500.0
	},
	{
		"value" : 32,
		"label" : "Pb",
		"minimumValue" : 3.0E-6,
		"maximumValue" : 8187.0
	},
	{
		"value" : 53,
		"label" : "Rh",
		"minimumValue" : 3.3E-5,
		"maximumValue" : 8.0
	},
	{
		"value" : 96,
		"label" : "He",
		"minimumValue" : 0.0015,
		"maximumValue" : 0.07
	},
	{
		"value" : 17,
		"label" : "Al",
		"minimumValue" : 5.0E-6,
		"maximumValue" : 14800.0
	},
	{
		"value" : 92,
		"label" : "Ar",
		"minimumValue" : 0.007,
		"maximumValue" : 1.57
	},
	{
		"value" : 87,
		"label" : "HS",
		"minimumValue" : 1.0E-4,
		"maximumValue" : 1002.0
	},
	{
		"value" : 85,
		"label" : "OH",
		"minimumValue" : 0.2,
		"maximumValue" : 20910.0
	},
	{
		"value" : 95,
		"label" : "H2",
		"minimumValue" : 0.023,
		"maximumValue" : 2.95
	},
	{
		"value" : 24,
		"label" : "Cs",
		"minimumValue" : 3.0E-6,
		"maximumValue" : 14950.0
	}
]

export const chemicalElements = {
	K: 1,
	Na: 2,
	Ca: 3,
	Mg: 4,
	SiO2: 5,
	As: 6,
	B: 7,
	Ba: 8,
	Br: 9,
	Cl: 10,
	F: 11,
	Fe: 12,
	Li: 13,
	Mn: 14,
	Sr: 15,
	Ag: 16,
	Al: 17,
	Au: 18,
	Be: 19,
	Bi: 20,
	Co: 21,
	Cd: 22,
	Cr: 23,
	Cs: 24,
	Cu: 25,
	Ga: 26,
	Ge: 27,
	Hg: 28,
	I: 29,
	Mo: 30,
	Ni: 31,
	Pb: 32,
	Rb: 33,
	S: 34,
	Sb: 35,
	Se: 36,
	Sn: 37,
	Th: 38,
	Ti: 39,
	Tl: 40,
	U: 41,
	V: 42,
	W: 43,
	Zn: 44,
	Zr: 45,
	In: 46,
	Sc: 47,
	Y: 48,
	Pd: 49,
	Re: 50,
	Pt: 51,
	Os: 52,
	Rh: 53,
	La: 54,
	Ce: 55,
	Pr: 56,
	Nd: 57,
	Sm: 58,
	Eu: 59,
	Gd: 60,
	Tb: 61,
	Dy: 62,
	Ho: 63,
	Er: 64,
	Tm: 65,
	Yb: 66,
	Lu: 67,
	Hf: 68,
	Nb: 69,
	Ta: 70,
	Te: 71,
	NO2: 72,
	NO3N: 73,
	NH4: 74,
	CO2: 75,
	PO4: 76,
	H2S: 77,
	SO3: 78,
	SO4: 79,
	HCO3: 80,
	CO3: 81,
	BO3: 82,
	KNa: 83,
	NO3: 84,
	OH: 85,
	P: 86,
	HS: 87,
	Si: 88,
	DIC: 89,
	DOC: 90,
	TOC: 91,
	Ar: 92,
	CH4: 93,
	C2H6: 94,
	H2: 95,
	He: 96,
	N2: 97,
	NH: 98,
	O2: 99,
};

export const reverseChemicalElements = Object.fromEntries(
	Object.entries(chemicalElements).map(([key, value]) => [value, key])
);

export const COUNTRIES = [
	{
		"label" : "Afghanistan",
		"value" : "Afghanistan"
	},
	{
		"label" : "Austraia",
		"value" : "Austraia"
	},
	{
		"label" : "Bolivia",
		"value" : "Bolivia"
	},
	{
		"label" : "Chile",
		"value" : "Chile"
	},
	{
		"label" : "China",
		"value" : "China"
	},
	{
		"label" : "Djibouti",
		"value" : "Djibouti"
	},
	{
		"label" : "Dominica",
		"value" : "Dominica"
	},
	{
		"label" : "Ethiopia ",
		"value" : "Ethiopia "
	},
	{
		"label" : "Iceland",
		"value" : "Iceland"
	},
	{
		"label" : "India",
		"value" : "India"
	},
	{
		"label" : "Italy",
		"value" : "Italy"
	},
	{
		"label" : "Mexico",
		"value" : "Mexico"
	},
	{
		"label" : "New Zealand",
		"value" : "New Zealand"
	},
	{
		"label" : "Russia",
		"value" : "Russia"
	},
	{
		"label" : "Serbia",
		"value" : "Serbia"
	},
	{
		"label" : "Sri Lanka",
		"value" : "Sri Lanka"
	},
	{
		"label" : "USA",
		"value" : "USA"
	}
]


export const ELEMENTS_COLUMNS = [
	{
		label: "id",
		value: "id"
	},
	{
		label: "title",
		value: "title"
	},
	{
		label: "production",
		value: "production"
	},
]